import { TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { portalRoles, UserRequest, CurrentUser, CurrentUserWithRequest, UpdateRequest } from "./user-management.entities";
import { UserManagementLookups } from "./user-management.lookups";
import { UserFormBuilder } from "./user-management.form";
declare var $: any;
export class UserManagementPage {
    newUserRequests: UserRequest[];
    updateRequests: UpdateRequest[];

    pendingNewRequests: UserRequest[];
    previousNewRequests: UserRequest[];

    pendingUdpateRequests: UpdateRequest[];
    previousUpdateRequests: UpdateRequest[];

    newTable: NewUserRequestTable;
    updateTable: CurrentUserWithRequestTable;
    previousNewRequestTable: PreviousUserRequestTable;
    previousUpdateRequestTable: PreviousUserRequestTable;

    currentUsers: CurrentUser[];
    currentTable: CurrentUserTable;
    affiliations: any;
    mapRoles: any;
    sites: any;
    errorMessageAll: JQuery<HTMLElement>;

    constructor(currentUsers: CurrentUser[], newUserRequests: UserRequest[], updateRequests: UpdateRequest[], affiliations: any, roles: any, sites: any) {
        this.currentUsers = currentUsers;
        this.newUserRequests = newUserRequests;
        this.updateRequests = updateRequests;       
        $(() => {
            this.pendingNewRequests = this.newUserRequests.filter(r => r.StatusId === 1);
            this.previousNewRequests = this.newUserRequests.filter(r => r.StatusId === 2 || r.StatusId === 3); 
            this.pendingUdpateRequests = this.updateRequests.filter(r => r.StatusId === 1);
            this.previousUpdateRequests = this.updateRequests.filter(r => r.StatusId === 2 || r.StatusId === 3);
            this.errorMessageAll = $("#all-error-message"); 
            this.sites = sites.filter(s => !s.IsArchived);
            this.affiliations = affiliations;            
            this.mapRoles = this.applyDisplayNames(roles);      
            this.initializeTables();
            this.initializeListSelector();
            this.updateRequestCounts();           
            this.openCreateNewModal();          
            this.initalizeListeners();
        });
    }

    private updateRequestCounts(): void {
        $("#user-request-count").text(this.pendingNewRequests.length);
        $("#user-update-count").text(this.pendingUdpateRequests.length);
    }


    private readonly roleDisplayNames: Record<string, string> = {
        "Trials1and2": "Core Protocol Working Group",
        "LDNTrial": "Trial - LDN",
        "VUMCBariTrial": "Trial - VUMC Bari",
        "Trial-GLP1": "Trial - GLP-1",
        "Trial-SGB": "Trial - SGB",
        "RVLC-Safety-Monitoring": "RVLC Safety Monitoring",
        "LDN-Bioequivalence": "LDN Bioequivalence",
        "Vendor-Alcami": "Vendor - Alcami",
        "Vendor-ICON": "Vendor - ICON",
    };

    private applyDisplayNames(roles: portalRoles[]): portalRoles[] {
        return roles.map(role => ({
            ...role,
            DisplayName: this.roleDisplayNames[role.Name] ?? role.Name
        }));
    }
 

    initalizeListeners() {

        $(window).on('resize', () => {
            this.currentTable?.table?.columns.adjust();
            this.newTable?.table?.columns.adjust();
            this.updateTable?.table?.columns.adjust();
            this.previousNewRequestTable?.table?.columns.adjust();
            this.previousUpdateRequestTable?.table?.columns.adjust();
        });
        $(document).on("click","#approve-new-user", async (e) => {
            e.preventDefault();
            let isValid = this.validateAddApproveModal();

            if (isValid) {
                this.setModalProcessing(true);
                let accountRequest: UserRequest = this.verifyAccountRequest();
                await this.approveNewUser(accountRequest, true);
            }
        })
        $(document).on("click", "#deny-new-user", async (e) => {
            e.preventDefault();

            const request = AddApproveModal.selectedRequest;
            if (!request) return;

            this.setModalProcessing(true);

            await this.denyNewUserRequest({
                Id: request.Id,               
            });
           
        });
        $(document).on("click", "#create-new-user", async (e) => {
            e.preventDefault();
            let isValid = this.validateAddApproveModal();

            if (isValid) {
                this.setModalProcessing(true);
                let createAccount: UserRequest = this.verifyAccountRequest();
                await this.createNewUser(createAccount, true);
            }
        });
        $(document).on("click", "#update-user", async (e) => {
            e.preventDefault();

            let isValid = this.validateAddApproveModal();

            if (isValid) {
                this.setModalProcessing(true);
                let updatedUser: UserRequest = this.verifyAccountRequest();
                await this.updateUser(updatedUser);
            }
        });
        $(document).on("click", "#approve-update-user", async (e) => {
            e.preventDefault();
            const request = AddApproveModal.selectedRequest;
            if (!request) return;
            this.setModalProcessing(true);
            await this.approveUserUpdate({ UserEmail: request.Email, RequestId: request.Id });
        });
        $(document).on("click", "#deny-update-user", async (e) => {
            e.preventDefault();

            const request = AddApproveModal.selectedRequest;
            if (!request) return;

            this.setModalProcessing(true);

            await this.denyUserUpdateRequest({
                Id: request.Id,
            });
        });
        $(document).on("click", "#check-teams-btn", (e) => {
            e.preventDefault();
            this.openTeamsAccessMenuModal(this.currentUsers);
        })
        if ($("#floating-action-menu").length === 0) {
            $("body").append(`<div id="floating-action-menu" class="action-popup-menu"></div>`);
        }

        $(document).on("click", ".action-popup-btn", function (e) {
            e.stopPropagation();
            const btn = $(this);
            const menu = $("#floating-action-menu");
            const userEmail = btn.data("user-email");

            // If already open for this button, close it
            if (menu.is(":visible") && menu.data("active-email") === userEmail) {
                menu.hide();
                return;
            }

            // Build menu items from the hidden template in the row
            const row = btn.closest("tr");
            const isActive = btn.closest(".user-actions-btn-group").find(".action-popup-item[data-action='deactivate']").length > 0;
            const email = userEmail;

            menu.html(`
            <div class="action-popup-item nowrap" data-action="edit-user" data-user-email="${email}"><i class="fa-solid fa-pencil mr-2"></i>Edit User</div>
            <div class="action-popup-item nowrap" data-action="check-teams" data-user-email="${email}"><i class="fa-solid fa-check mr-2"></i>Check Teams Access</div>
            <div class="action-popup-item nowrap" data-action="send-welcome" data-user-email="${email}"><i class="fa-solid fa-envelope mr-2"></i>Send Welcome Email</div>
            <div class="action-popup-item nowrap" data-action="send-password" data-user-email="${email}"><i class="fa-solid fa-envelope mr-2"></i>Send Password Reset</div>
            ${isActive  ? `<div class="action-popup-item nowrap" data-action="deactivate" data-user-email="${email}"><i class="fa-solid fa-ban mr-2"></i>Deactivate User's Account</div>`
               : `<div class="action-popup-item nowrap" data-action="reactivate" data-user-email="${email}"><i class="fa-solid fa-arrow-rotate-left mr-2"></i>Reactivate User's Account</div>`
            }`);

            // Position relative to viewport
            const rect = (this as HTMLElement).getBoundingClientRect();
            let top = rect.bottom + 4;
            let left = rect.left;

            menu.data("active-email", userEmail);
            menu.css({ top: top, left: left }).show();

            // Flip upward if it would go off-screen
            const menuHeight = menu.outerHeight();
            if (top + menuHeight > window.innerHeight) {
                menu.css("top", rect.top - menuHeight - 4);
            }

            // Flip left if it would overflow right edge
            const menuWidth = menu.outerWidth();
            if (left + menuWidth > window.innerWidth) {
                menu.css("left", rect.right - menuWidth);
            }
        });

        $(document).on("click", function (e) {
            if (!$(e.target).closest("#floating-action-menu, .action-popup-btn").length) {
                $("#floating-action-menu").hide();
            }
        });

        $(document).on("click", ".action-popup-menu", function (e) {
            e.stopPropagation();
        });

        // Close on table scroll
        $(`#current-user-table`).closest(".dataTables_scrollBody").on("scroll", () => {
            $("#floating-action-menu").hide();
        });

        $(document).on("click", ".action-popup-item", async (e) => {
            $("#floating-action-menu").hide();
            const item = $(e.currentTarget);
            const action = item.data("action");
            const userEmail = item.data("userEmail");

            switch (action) {
                case "check-teams":                   
                    await this.openUserTeamsAccessModal(userEmail);
                break;

                case "send-welcome":                  
                    await this.openWelcomeEmailModal(userEmail);
                break;

                case "edit-user":
                    await this.openEditUserModal(userEmail);
                break;

                case "send-password":                    
                    await this.openPasswordResetEmailModal(userEmail);
                break;

                case "deactivate":
                    await this.openDeactivateUserModal(userEmail);
                    break;

                case "reactivate":
                    await this.openReactivateUserModal(userEmail);
                break;
            }
            const group = item.closest(".user-actions-btn-group");
            group.removeClass("menu-open");
        }); 
        $('#previous-request-table').on('shown.bs.collapse', () => {
            const prevTable = $("#previous-user-requests-table").DataTable();
            prevTable.columns.adjust().draw();
        });
        $('#previous-update-table').on('shown.bs.collapse', () => {
            const prevTable = $("#previous-update-requests-table").DataTable();
            prevTable.columns.adjust().draw();
        });

       
    }

    initializeTables(): void {
        this.currentTable = new CurrentUserTable("current-user-table", this.currentUsers, this.mapRoles);
       
        this.newTable = new NewUserRequestTable("new-user-table", this.pendingNewRequests, this.affiliations, this.mapRoles, this.sites );

        this.updateTable = new CurrentUserWithRequestTable("update-user-table", this.pendingUdpateRequests, this.affiliations, this.mapRoles, this.sites);

        this.previousNewRequestTable = new PreviousUserRequestTable("previous-user-requests-table", this.previousNewRequests, "#prev-new-search");

        this.previousUpdateRequestTable = new PreviousUserRequestTable("previous-update-requests-table",this.previousUpdateRequests, "#prev-update-search");
    }

    switchTable(selected: JQuery, tableId: string): void {
        $(".list-item-selector").removeClass("active");
        selected.addClass("active");
        $(".table-container").addClass("d-none");
        const container = $(`#${tableId}`).closest(".table-container");
        container.removeClass("d-none");
        const table = $(`#${tableId}`).DataTable();
        table.columns.adjust().draw();

        if (tableId === "new-user-table") {
            const prevTable = $("#previous-user-requests-table").DataTable();
            prevTable.columns.adjust().draw();
        }

        if (tableId === "update-user-table") {
            const prevTable = $("#previous-update-requests-table").DataTable();
            prevTable.columns.adjust().draw();
        }
    }

    initializeListSelector(): void {
        const container = $("#user-management-content");

        container.on("click", ".list-item-selector", (e) => {
            const selector = $(e.currentTarget);
            const tableId = selector.data("table");

            this.switchTable(selector, tableId);
        });
    }

    openCreateNewModal(): void {
        const addNewBtn = $("#add-new-btn");

        addNewBtn.on("click", (e) => {
            AddApproveModal.open("create", null, null, this.affiliations, this.mapRoles, this.sites);
        })
    }

    closeAllModals() {
        $(".modal").modal('hide');
        AddApproveModal.selectedRequest = null;
        AddApproveModal.selectedCurrentUser = null;
    }
    closeAllModalsAndRefresh() {
        $(".modal").modal('hide');
        AddApproveModal.selectedRequest = null;
        AddApproveModal.selectedCurrentUser = null;
        window.location.reload();
    }

    setModalProcessing(isProcessing: boolean) {
        const modal = $("#add-approve-modal");
        const body = modal.find(".modal-body");       
        const buttons = modal.find("#modal-footer-buttons");
        const spinner = modal.find("#modal-processing");

        if (isProcessing) {
            body.addClass("d-none");
            buttons.removeClass("d-flex").addClass("d-none");
            spinner.removeClass("d-none").addClass("d-block");
        } else {
            buttons.removeClass("d-none").addClass("d-flex");
            spinner.removeClass("d-block").addClass("d-none");
        }
    }

    // ----Modal Functions---

    private validateAddApproveModal(): boolean {
        let isValid = true;

        // Loop all required labels
        $("#user-form label.required:visible").each((_, label) => {

            const container = $(label).closest("[data-field-container]");
            const input = container.find("input, select").first();
            const errorMessage = container.find(".validation-msg");

            if (input.length === 0) return;

            const type = input.attr("type");

            if (type !== "checkbox") {
                    const value = (input.val() as string)?.trim();
                    const fieldId = input.attr("id");

                    let fieldValid = true;

                    if (!value) {
                        fieldValid = false;
                    }

                    if (fieldValid && fieldId === "Input_Email") {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        fieldValid = emailRegex.test(value);
                    }                               

                    if (!fieldValid) {
                        isValid = false;
                        errorMessage.removeClass("d-none");
                    } else {
                        errorMessage.addClass("d-none");
                    }
            }

            if (type === "checkbox") {
                if (!input.is(":checked")) {
                    isValid = false;
                    errorMessage.removeClass("d-none");
                } else {
                    errorMessage.addClass("d-none");
                }
            }
        });

        if (!isValid) {
            this.errorMessageAll.removeClass("d-none");
        } else {
            this.errorMessageAll.addClass("d-none");
        }

        return isValid;
    }

    private verifyAccountRequest(): UserRequest {
        const original = AddApproveModal.selectedRequest;
        let accountRequest = new UserRequest();
        if (original) {
            accountRequest.Id = original.Id;
            accountRequest.StatusId = original.StatusId;
            accountRequest.UserId = original.UserId;
        }


        // Personal Information
        let email = <string>$("#Input_Email").val();
        if (email) accountRequest.Email = email.trim();

        let firstName = <string>$("#Input_FirstName").val();
        if (firstName) accountRequest.FirstName = firstName.trim();

        let lastName = <string>$("#Input_LastName").val();
        if (lastName) accountRequest.LastName = lastName.trim();

        let orgName = <string>$("#Input_Organization").val();
        if (orgName) accountRequest.Organization = orgName.trim();

        let tlcRole = <string>$("#Input_TLCRole").val();
        if (tlcRole) accountRequest.TLCRole = tlcRole.trim();

        // Affiliation and Site Info
        let affiliationId = <string>$("#Input_AffiliationId").val();
        if (affiliationId) {
            let affId = parseInt(affiliationId);
            if (affId) accountRequest.AffiliationId = affId;
        }

        let siteId = <string>$("#Input_SiteId").val();
        if (siteId) {
            let Id = parseInt(siteId);
            if (Id) accountRequest.SiteId = Id;
        }

        //Trial Access
        const roles: portalRoles[] = window['roles'] ?? [];
        accountRequest.Roles = roles
            .filter(role => $(`#Input_${role.Name}`).is(":checked"))
            .map(role => role.Name);

   

        return accountRequest;
    }

    private async openEditUserModal(userEmail:string) {
        try {
            const userToEdit = await this.getUserToEdit(userEmail);
            AddApproveModal.open("edit-user", userToEdit, null, this.affiliations, this.mapRoles, this.sites);
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
        }
    }

    private toggleTeamsCard(header: HTMLElement): void {
        const body = header.nextElementSibling as HTMLElement;
        const icon = header.querySelector(".rotate-icon") as HTMLElement;

        const isHidden = body.style.display === "none" || !body.style.display;

        body.style.display = isHidden ? "block" : "none";

        if (icon) {
            icon.classList.toggle("rotated", isHidden);
        }
    }

    private async openWelcomeEmailModal(userEmail: string): Promise<void> {

        const modal = $("#welcome-email-modal");
        const body = modal.find(".modal-body");
        const footer = modal.find(".modal-footer");
        footer.hide();
        body.html(`
        <div class="text-center p-4">
            <p>Are you sure you want to send a welcome email to <strong>${userEmail}</strong>?</p>
        </div>
        `);
        footer.html(`
        <div class="d-flex justify-content-end gap-2">
            <button class="btn user-management-btn-save mr-3" id="confirm-send-email">Send</button>
            <button class="btn user-management-btn" id="cancel-send-email">Cancel</button>
        </div>
        `);
        footer.show();
        modal.modal("show");

       
        modal.off("click", "#cancel-send-email").on("click", "#cancel-send-email", () => {
            modal.modal("hide");
        });

        modal.off("click", "#confirm-send-email").on("click", "#confirm-send-email", async () => { 
            footer.hide();
            body.html(`
            <div class="text-center p-4">            
                <div class="mt-3">Sending welcome email...</div>
                <div class="spinner-border mt-2" role="status"></div>
            </div>
        `);

            try {
                await this.sendWelcomeEmail(userEmail);
           
                body.html(`
                <div class="text-center p-4">
                    <h5>Welcome email sent</h5>
                    <p>The email was successfully delivered to ${userEmail}.</p>
                </div>  `);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);
            } catch (error) {

                body.html(`
                <div class="text-center p-4">
                    <h5 class="text-danger">Failed to send email</h5>
                    <p>Please refresh the page and try again.</p>                  
                </div>`);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);
            }
            footer.show();
        });
    }

    private async openDeactivateUserModal(userEmail: string): Promise<void> {

        const modal = $("#welcome-email-modal");
        const body = modal.find(".modal-body");
        const footer = modal.find(".modal-footer");

        footer.hide();
        body.html(`
        <div class="text-center p-4">
            <p>Are you sure you want to deactivate <strong>${userEmail}'s</strong> account? They will not be able to login or access the private portal anymore.</p>
        </div>
        `);
        footer.html(`
        <div class="d-flex justify-content-end gap-2">
            <button class="btn user-management-btn-save mr-3" id="confirm-deactivate">Confirm</button>
            <button class="btn user-management-btn" id="cancel-deactivate">Cancel</button>
        </div>
        `);
        footer.show();
        modal.modal("show");


        modal.off("click", "#cancel-deactivate").on("click", "#cancel-deactivate", () => {
            modal.modal("hide");
        });

        modal.off("click", "#confirm-deactivate").on("click", "#confirm-deactivate", async () => {
            footer.hide();
            body.html(`
            <div class="text-center p-4">            
                <div class="mt-3">Processing request...</div>
                <div class="spinner-border mt-2" role="status"></div>
            </div>
        `);

            try {
                await this.deactivateUser(userEmail);

                body.html(`
                <div class="text-center p-4">
                    <h5>Account Deactivated</h5>
                    <p>${userEmail}'s account was successfully deactivated.</p>
                </div>`);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModalsAndRefresh()">Close</button>
                </div>`);
            } catch (error) {

                body.html(`
                <div class="text-center p-4">
                    <h5 class="text-danger">Failed to process request</h5>
                    <p>Please refresh the page and try again.</p>                  
                </div>`);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);
            }
            footer.show();
        });
    }

    private async openReactivateUserModal(userEmail: string): Promise<void> {

        const modal = $("#welcome-email-modal");
        const body = modal.find(".modal-body");
        const footer = modal.find(".modal-footer");
        footer.hide();
        body.html(`
        <div class="text-center p-4">
            <p>Are you sure you want to reactivate <strong>${userEmail}'s</strong> account? They will be able to login and access the private portal.</p>
        </div>
    `);
        footer.html(`
        <div class="d-flex justify-content-end gap-2">
            <button class="btn user-management-btn-save mr-3" id="confirm-reactivate">Confirm</button>
            <button class="btn user-management-btn" id="cancel-reactivate">Cancel</button>
        </div>
    `);
        footer.show();
        modal.modal("show");


        modal.off("click", "#cancel-reactivate").on("click", "#cancel-reactivate", () => {
            modal.modal("hide");
        });

        modal.off("click", "#confirm-reactivate").on("click", "#confirm-reactivate", async () => {
            footer.hide();
            body.html(`
            <div class="text-center p-4">            
                <div class="mt-3">Processing request...</div>
                <div class="spinner-border mt-2" role="status"></div>
            </div>
        `);

            try {
                await this.reactivateUser(userEmail);

                body.html(`
                <div class="text-center p-4">
                    <h5>Account Reactivated</h5>
                    <p>${userEmail}'s account was successfully reactivated.</p>
                </div>`);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModalsAndRefresh()">Close</button>
                </div>`);

            } catch (error) {

                body.html(`
                <div class="text-center p-4">
                    <h5 class="text-danger">Failed to process request</h5>
                    <p>Please refresh the page and try again.</p>                  
                </div>`);
                footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);
            }
            footer.show();
        });
    }

    private async openPasswordResetEmailModal(userEmail: string): Promise<void> {

        const modal = $("#welcome-email-modal");
        const body = modal.find(".modal-body");
        const footer = modal.find(".modal-footer");
        footer.hide();
        body.html(`
        <div class="text-center p-4">
            <p>Are you sure you want to send a password reset email to <strong>${userEmail}</strong>?</p>
        </div>
        `);
        footer.html(`
        <div class="d-flex justify-content-end gap-2">
            <button class="btn user-management-btn-save mr-3" id="confirm-send-email">Send</button>
            <button class="btn user-management-btn" id="cancel-send-email">Cancel</button>
        </div>
        `);
        footer.show();
        modal.modal("show");


        modal.off("click", "#cancel-send-email").on("click", "#cancel-send-email", () => {
            modal.modal("hide");
        });

        modal.off("click", "#confirm-send-email").on("click", "#confirm-send-email", async () => {
            footer.hide();
            body.html(`
            <div class="text-center p-4">            
                <div class="mt-3">Sending email...</div>
                <div class="spinner-border mt-2" role="status"></div>
            </div>
            `);

        try {
            await this.sendPasswordResetEmail(userEmail);

            body.html(`
            <div class="text-center p-4">
                <h5>Password reset email sent</h5>
                <p>The email was successfully delivered to ${userEmail}.</p>              
            </div>`);
            footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);

        } catch (error) {

            body.html(`
            <div class="text-center p-4">
                <h5 class="text-danger">Failed to send email</h5>
                <p>Please refresh the page and try again.</p>              
            </div>`);
            footer.html(`
                <div class="mt-4 d-flex justify-content-end gap-2">
                 <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
                </div>`);
            }
            footer.show();
        });
    } 

    private async openUserTeamsAccessModal(userEmail: string): Promise<void> {
        const modal = $("#teams-access-modal");
        const body = modal.find(".modal-body");
        const dialog = modal.find(".modal-dialog");
        const footer = modal.find(".modal-footer");

        dialog.removeClass("modal-full").addClass("modal-sm");
        footer.hide();

        body.html(`
        <div class="text-center p-4">            
            <div class="mb-3">Checking Teams access...</div>
            <div class="spinner-border" role="status"></div>
        </div>
    `);

        modal.modal("show");

        try {
            const teams = await this.checkUserTeamsAccess(userEmail);

            if (!teams || teams.length === 0) {
                body.html(`
                <div class="text-center secure-page-title p-4">
                    <h6>No Teams access required</h6>
                </div>
            `);
                footer.html(`
                <div class="d-flex justify-content-end">
                    <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
                </div>
            `);
                footer.show();
                return;
            }

            const tableRows = teams.map(t => `
            <tr class="${t.NeedsAdd || t.NeedsRemove ? 'needs-row' : ''}">
                <td>
                    ${t.TeamDisplayName}
                    ${t.TeamLink ? `<a href="${t.TeamLink}" target="_blank" class="ms-2"><i class="fas fa-external-link-alt"></i></a>` : ''}
                </td>
                <td>${t.NeedsAdd ? 'Yes' : 'No'}</td>
                <td>${t.NeedsRemove ? 'Yes' : 'No'}</td>
            </tr>
        `).join('');

            dialog.removeClass("modal-sm").addClass("modal-full");

            body.html(`
            <div class="p-3">
                <div class="secure-page-title">
                    <h6>Teams Access for ${userEmail}</h6>
                </div>
                <table class="ctms-table teams-table w-100">
                    <thead>
                        <tr>
                            <th>Channel Name</th>
                            <th>Needs to be Added?</th>
                            <th>Needs to be Removed?</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>
            </div>
        `);

            footer.html(`
            <div class="d-flex justify-content-end">
                <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
            </div>
        `);
            footer.show();

        } catch (error) {
            body.html(`
            <div class="text-center p-4">
                <h5 class="text-danger">Failed to check Teams access</h5>
                <p>Please refresh the page and try again.</p>
            </div>
        `);
            footer.html(`
            <div class="d-flex justify-content-end">
                <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
            </div>
        `);
            footer.show();
        }
    }

    private async openTeamsAccessMenuModal(users: CurrentUser[]): Promise<void> {
        const modal = $("#teams-access-modal");
        const body = modal.find(".modal-body");
        const dialog = modal.find(".modal-dialog");
        const footer = modal.find(".modal-footer");
        dialog.removeClass("modal-full").addClass("modal-md");
        footer.hide();
        body.html(`
        <div class="p-4 text-center">
            <div class="mb-3 teams-loading-header">
                <h5>Teams Access Tools</h5>
            </div>

            <div class="d-grid d-flex justify-content-center gap-3">
                <button id="check-user-access" class="user-management-btn mr-3">
                    Check Teams Access
                </button>

                <button id="check-removal-access" class="user-management-btn">
                    Check Users To Remove
                </button>
            </div>           
        </div>
        `);

        modal.modal("show");

        $(document).off("click", "#check-user-access").on("click", "#check-user-access", async () => {
            await this.checkAllTeamsChannelsAccess(users);
        });

        // OPTION 2: Users to remove
        $(document).off("click", "#check-removal-access").on("click", "#check-removal-access", async () => {
            await this.checkTeamsUsersToRemove(users);
        });
       
    }
   
    private async checkAllTeamsChannelsAccess(users: CurrentUser[]): Promise<void> {
        const modal = $("#teams-access-modal");
        const body = modal.find(".modal-body");
        const dialog = modal.find(".modal-dialog");
        const footer = modal.find(".modal-footer");
        dialog.removeClass("modal-full").addClass("modal-sm");     

        // Show loading spinner
        body.html(`
        <div class="text-center p-4">
            <div class="mb-3">Checking Teams access...</div>
            <div class="spinner-border" role="status"></div>
        </div>
    `);

        try {
            const response = await this.checkTeamsAccessAll(users);

            let html = `
            <div class="p-3">
                <div class="secure-page-title mb-3"><h5>Teams Access Results</h5></div>
        `;

            response.forEach((team) => {
                const needsAction = team.missingMembers && team.missingMembers.length > 0;
                const actionIcon = needsAction
                    ? `<i class="fa-solid fa-exclamation teams-warning" style="margin-right:6px;"></i>`
                    : `<i class="fa-solid fa-check teams-good" style="margin-right:6px;"></i>`;
                const headerText = `${team.teamDisplayName}`;
                html += `
                <div class="teams-card mb-2">
                    <div class="teams-card-header" onclick="page.toggleTeamsCard(this)">
                            <strong> ${actionIcon}${headerText}<i class="fas fa-plus rotate-icon ml-2"></i> </strong>                 
                        </div>
                    <div class="teams-card-body" style="display:none; padding:10px; background:#f9f9f9;">
                        <div style="display:flex; gap:20px; flex-wrap:wrap;">
                            <div style="flex:1; min-width:150px;">
                                <p style="margin-bottom:6px;">Added To Team</p>
                                ${team.foundMembers?.length ? team.foundMembers.map(email => `<div style="padding:2px 4px; margin-bottom:2px; border-radius:4px;">${email}</div>`).join("") : "<div style='font-style:italic; color:#888;'>None</div>" }
                            </div>
                            <div style="flex:1; min-width:150px;">
                                <p style="margin-bottom:6px;">Missing ${team.teamsLink ? `<a href="${team.teamsLink}" target="_blank"><i class="fas fa-external-link-alt teamsLink"></i></a>` : ''}</p>
                                ${team.missingMembers?.length ? team.missingMembers.map(email => `<div style="padding:2px 4px; margin-bottom:2px; border-radius:4px;">${email}</div>`).join("") : "<div style='font-style:italic; color:#888;'>None</div>" }
                            </div>
                        </div>
                    </div>
                </div>
            `;
            });
            dialog.removeClass("modal-sm").addClass("modal-full");
              

            body.html(html);
            footer.html(`
             <div class="text-center d-flex justify-content-end mt-3">
                <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
                </div>
             </div>
            `);      

        } catch (error) {
            console.error(error);
            footer.html(`
            <div class="text-center d-flex justify-content-end p-4">
                <h5 class="text-danger">Failed to check Teams access</h5>
                <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
            </div>
        `);
        }
    }

    private async checkTeamsUsersToRemove(users: CurrentUser[]): Promise<void> {

        const modal = $("#teams-access-modal");
        const body = modal.find(".modal-body");
        const dialog = modal.find(".modal-dialog");
        const footer = modal.find(".modal-footer");
        dialog.removeClass("modal-full").addClass("modal-md");

        body.html(`
        <div class="text-center p-4">            
            <div class="mb-3">Finding users that should be removed...</div>
            <div class="spinner-border" role="status"></div>
        </div>
    `);

        try {
            const response = await this.getRemoveTeamsAccess(users);

            let html = `
            <div class="p-3">
                <div class="secure-page-title mb-3"><h5>Users to remove</h5></div>
                <div><p>Each Channel below has members to remove.</p></div>
        `;
            let hasRemovals = false;
            response.forEach((team) => {
                if (team.missingMembers && team.missingMembers.length > 0) {
                    hasRemovals = true;
                    html += `
                        <div class="teams-card mb-2">
                        <div class="teams-card-header" onclick="page.toggleTeamsCard(this)">
                            <strong> <i class="fa-solid fa-exclamation teams-warning" style="margin-right:6px;"></i> ${team.teamDisplayName}<i class="fas fa-plus rotate-icon ml-2"></i> </strong>
                        </div>
                        <div class="teams-card-body" style="display:none; padding:10px; background:#f9f9f9;">
                            <div style="display:flex; gap:20px; flex-wrap:wrap;">                             
                                <div style="flex:1; min-width:150px;">
                                    <p style="margin-bottom:6px;">Members to Remove: ${team.teamsLink ? `<a href="${team.teamsLink}" target="_blank"><i class="fas fa-external-link-alt teamsLink"></i></a>` : ''} </p>
                                    ${team.missingMembers?.length ? team.missingMembers.map(email => `<div style="padding:2px 4px; margin-bottom:2px; border-radius:4px;">${email}</div>`).join("") : "<div style='font-style:italic; color:#888;'>None</div>"}
                                </div>
                            </div>
                        </div>
                    </div>
                   `;
                }              
                
            });   
            if (!hasRemovals) {
                html += `
                   <div class="text-center p-4">
                      <h5>No members need to be removed!</h5>
                   </div>                      
                `;
            }
            dialog.removeClass("modal-sm").addClass("modal-full");

            footer.html(`
             <div class="text-center d-flex justify-content-end mt-3">
                <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
                </div>
             </div>
            `);      

            body.html(html);

        } catch {

           
            body.html(`<h5 class="text-danger">Failed to check users</h5>`);
             footer.html(` <div class="text-center  d-flex justify-content-end p-4">              
                <button class="btn user-management-btn mt-3" onclick="page.closeAllModals()">Close</button>
            </div>
        `);
        }
    }

    // =====PROMISES====
    async approveNewUser(data: any, sendWelcomeEmail: boolean = true,): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=ApproveNewUserRequest",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                    sendWelcomeEmail: sendWelcomeEmail
                }
            });

            this.closeAllModals();
            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async createNewUser(data: any, sendWelcomeEmail: boolean = true): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=CreateNewUser",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                    sendWelcomeEmail: sendWelcomeEmail
                }
            });
            this.closeAllModals();
            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async denyNewUserRequest(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=DenyNewUserRequest",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                }
            });

            this.closeAllModals();

            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async denyUserUpdateRequest(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=DenyUserUpdateRequest",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                }
            });

            this.closeAllModals();

            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async getUserToEdit(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=GetUserForEdit",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),                  
                }
            });          
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async updateUser(data: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=UpdateUser",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                }
            });
            this.closeAllModals();
            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async approveUserUpdate(data: { RequestId: number; UserEmail: string }): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=ApproveUserUpdate",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(data),
                }
            });

            this.closeAllModals();
            window.location.reload();
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async deactivateUser(userEmail: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=DeactivateUser",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(userEmail),
                }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async reactivateUser(userEmail: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=ReactivateUser",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(userEmail),
                }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async sendWelcomeEmail(userEmail: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=SendWelcomeEmail",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(userEmail),
                }
            });

            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async sendPasswordResetEmail(userEmail: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=SendPasswordReset",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(userEmail),
                }
            });

            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async checkUserTeamsAccess(userEmail: any): Promise<any> {
        try {
            const result = await $.ajax({
                url: "?handler=GetMembership",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(userEmail),
                }
            });

            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async checkTeamsAccessAll(users: any) {
        try {
            const result = await $.ajax({
                url: "?handler=GetTeamsMembershipAll",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(users),
                }
            });

            return result;
        }
        catch (error) {
            alert("An error has occured, please refresh the page and try again.")
            console.log(error);
        }
    }

    async getRemoveTeamsAccess(users: any) {
        try {
            const result = await $.ajax({
                url: "?handler=GetTeamsMembersToRemove",
                method: "POST",
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val()
                },
                data: {
                    data: JSON.stringify(users),
                }
            });

            return result;
        }
        catch (error) {
            alert("An error has occured, please refresh the page and try again.")
            console.log(error);
        }
    }
}

// ---TABLES---

class CurrentUserTable {
    tableId: string;
    table: any;
    data: CurrentUser[];   
    roles: portalRoles[];
    constructor(tableId: string, data: CurrentUser[], roles: portalRoles[]) {
        this.tableId = tableId;
        this.data = data;
        this.roles = roles
        this.initialize();
    }

    initialize(): void {
        this.table = $(`#${this.tableId}`).DataTable({           
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: true,
            scroller: {
                boundaryScale: 0.75,
                displayBuffer: 100,
                serverwait: 0
            },
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            columns: this.getColumns(),
            /*buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                }
            ],*/
            data: this.data,
            order: [[0, 'asc']]
        });  
        this.populateFilters();
        this.bindFilters();    
    }

    getColumns(): any[] {
        return [
            {
                data: "Email", title: "Email", render: (data, type, row) => {
                    return `
                         <div class="d-flex justify-content-between align-items-center email-cell">
                         <span>${data}</span>
                         <div class="user-actions-btn-group">
                            <button class="btn action-popup-btn" data-user-email="${row.Email}">
                                <i class="fas fa-ellipsis"></i>
                            </button>
                            <div class="action-popup-menu">
                                <div class="action-popup-item nowrap" data-action="edit-user" data-user-email="${row.Email}"><i class="fa-solid fa-pencil mr-2"></i>Edit User</div>
                                <div class="action-popup-item nowrap" data-action="check-teams" data-user-email="${row.Email}"><i class="fa-solid fa-check mr-2"></i>Check Teams Access</div>
                                <div class="action-popup-item nowrap" data-action="send-welcome" data-user-email="${row.Email}"><i class="fa-solid fa-envelope mr-2"></i>Send Welcome Email</div>
                                <div class="action-popup-item nowrap" data-action="send-password" data-user-email="${row.Email}"><i class="fa-solid fa-envelope mr-2"></i>Send Password Reset</div> 
                                ${row.IsActive ? `<div class="action-popup-item nowrap" data-action="deactivate" data-user-email="${row.Email}"><i class="fa-solid fa-ban mr-2"></i>Deactivate User's Account</div>` : `<div class="action-popup-item nowrap" data-action="reactivate" data-user-email="${row.Email}"><i class="fa-solid fa-arrow-rotate-left mr-2"></i>Reactivate User's Account</div>`}
                                </div>
                            </div>
                         </div>
                    `;
                }
            },
            { data: "FirstName", title: "First Name" },
            { data: "LastName", title: "Last Name" },
            { data: "Organization", title: "Organization" },
            { data: "AffiliationId", title: "Affiliation", render: (data) => { return UserManagementLookups.getAffiliationName(data) }, className: "text-left nowrap" },
            { data: "TLCRole", title: "Project Role"},
            { data: "IsActive", title: "Active", render: (data: boolean) => data === true ? "Yes" : "No" },
            //{ data: "SentWelcomeEmail", title: "Sent Welcome Email"}           
        ];
    }
    populateFilters(): void {
        const affiliations = new Set<string>();
        const activeStatuses = new Set<string>();        
        const portalAccess = this.roles.map(r => r.Name);

        this.data.forEach(user => {
            affiliations.add(UserManagementLookups.getAffiliationName(user.AffiliationId));
            activeStatuses.add(user.IsActive ? "Yes" : "No");
        });
     
        this.fillSelect("#prime-aff", Array.from(affiliations));
        this.fillSelect("#isActive", Array.from(activeStatuses));
        this.fillSelect("#portal-access", Array.from(portalAccess));

        $('.selectpicker').selectpicker('refresh');
    }

    fillSelect(selector: string, values: string[]): void {
        const select = $(selector);
        select.empty();

        values.sort().forEach(v => {
            select.append(`<option value="${v}">${v}</option>`);
        });
    }

    bindFilters(): void {
        const table = this.table;

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
            const row = table.row(dataIndex).data() as CurrentUser;

            const selectedAff = $("#prime-aff").val() as string[];
            const selectedActive = $("#isActive").val() as string[];
            const selectedPortal = ($("#portal-access").val() as string[])?.map(r => r.toLowerCase().trim());
            const searchText = ($("#current-search").val() as string)?.toLowerCase();

            const affiliation = UserManagementLookups.getAffiliationName(row.AffiliationId);
            const isActive = row.IsActive ? "Yes" : "No";
            //const portal = row.TLCRole;

            if (selectedAff?.length && !selectedAff.includes(affiliation)) return false;
            if (selectedActive?.length && !selectedActive.includes(isActive)) return false;
            if (selectedPortal?.length) {
                const userRoles = row.Roles?.map(r => r.toLowerCase().trim()) ?? [];
                const hasRole = selectedPortal.some(role =>
                    userRoles.includes(role)
                );

                if (!hasRole) return false;
            }

            if (searchText) {
                const combined = `${row.Email} ${row.FirstName} ${row.LastName} ${row.Organization}`.toLowerCase();
                if (!combined.includes(searchText)) return false;
            }

            return true;
        });

        // trigger redraw on change
        $("#prime-aff, #isActive, #portal-access").on("change", () => {
            table.draw();
        });

        $("#current-search").on("keyup", () => {
            table.draw();
        });

        $("#current-search-clear").on("click", () => {
            $("#current-search").val("");
            table.draw();
        });
    }

    updateData(data: CurrentUser[]): void {
        this.table.clear();
        this.table.rows.add(data)
        this.table.draw(false);
    }   

}

class NewUserRequestTable {
    tableId: string;
    table: any;
    data: UserRequest[];
    affiliations: any;
    roles: any;
    sites: any;
    constructor(tableId: string, data: UserRequest[], affiliations: any, roles: any, sites: any) {
        this.tableId = tableId;
        this.data = data;
        this.affiliations = affiliations;
        this.roles = roles;
        this.sites = sites;
        this.initialize();
    }

    initialize(): void {
        this.table = $(`#${this.tableId}`).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            columns: this.getColumns(),          
            data: this.data,
            order: [[0, 'asc']]
        });       
        this.bindSearch();
        this.openApproveModal();
    }
    
    getColumns(): any[] {
        if (this.tableId === 'new-user-table') {
            return [
                { data: "StatusId", title: "Status", render: (data) => { return UserManagementLookups.getDisplayStatus(data) }, className: "text-left nowrap" },
                { data: "Email", title: "Email", className: "text-lef  nowrap" },
                { data: "FirstName", title: "First Name", className: "text-left nowrap" },
                { data: "LastName", title: "Last Name", className: "text-left nowrap" },
                { data: "Organization", title: "Organization", className: "text-left nowrap" },
                { data: "TLCRole", title: "Role", className: "text-left nowrap" },
                { data: "SiteInfo", title: "Site Info", className: "text-left nowrap" },
                { data: "AffiliationId", title: "Affiliation", render: (data) => { return UserManagementLookups.getAffiliationName(data) }, className: "text-left nowrap" },
            ];
        }     
    }

    bindSearch(): void {
        const table = this.table;

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
            const row = table.row(dataIndex).data() as CurrentUser;
          
            const searchText = ($("#new-search").val() as string)?.toLowerCase();

            if (searchText) {
                const combined = `${row.Email} ${row.FirstName} ${row.LastName} ${row.Organization}`.toLowerCase();
                if (!combined.includes(searchText)) return false;
            }

            return true;
        });

        $("#new-search").on("keyup", () => {
            table.draw();
        });

        $("#new-search-clear").on("click", () => {
            $("#current-search").val("");
            table.draw();
        });
    }

    updateData(data: UserRequest[]): void {
        //this.table.clear();
        this.table.columns.adjust();
        this.table.rows.add(data).draw();
    }

    openApproveModal(): void {
        const tableEl = $(`#${this.tableId}`);

        tableEl.on('click', 'tbody tr', (e) => {
            const rowData: UserRequest = this.table.row(e.currentTarget).data();
            if (!rowData) return;

            if (this.tableId === 'new-user-table') {
                AddApproveModal.open("approve-new", rowData, undefined, this.affiliations, this.roles, this.sites);
            }
        });
    }

}

class CurrentUserWithRequestTable {
    tableId: string;
    table: any;
    data: UpdateRequest[];
    affiliations: any;
    roles: any;
    sites: any;
    constructor(tableId: string, data: UpdateRequest[], affiliations: any, roles: any, sites: any) {
        this.tableId = tableId;
        this.data = data;
        this.affiliations = affiliations;
        this.roles = roles;
        this.sites = sites;
        this.initialize();
    }

    initialize(): void {
        this.table = $(`#${this.tableId}`).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            columns: this.getColumns(),           
            data: this.data,
            order: [[1, 'asc']]
        });
        this.bindSearch();
        this.openApproveModal();
    }

    bindSearch(): void {
        const table = this.table;

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
            const row = table.row(dataIndex).data() as UpdateRequest;

            const searchText = ($("#update-search").val() as string)?.toLowerCase();

            if (searchText) {
                const combined = `${row.Email} ${row.FirstName} ${row.LastName}`.toLowerCase();
                if (!combined.includes(searchText)) return false;
            }

            return true;
        });

        $("#update-search").on("keyup", () => {
            table.draw();
        });

        $("#update-search-clear").on("click", () => {
            $("#current-search").val("");
            table.draw();
        });
    }

    getColumns(): any[] {
        return [
            { data: "StatusId", title: "Status", render: (data) => UserManagementLookups.getDisplayStatus(data), className: "text-left nowrap" },
            { data: "TypeId", title: "Type", render: (data) => UserManagementLookups.getRequestType(data), className: "text-left nowrap"},
            { data: "Email", title: "Email", className: "text-left nowrap" },
            { data: "FirstName", title: "First Name", className: "text-left nowrap" },
            { data: "LastName", title: "Last Name", className: "text-left nowrap" }, 
        ];
    }

    openApproveModal(): void {
        const tableEl = $(`#${this.tableId}`);

        tableEl.on('click', 'tbody tr', (e) => {
            const rowData: UpdateRequest = this.table.row(e.currentTarget).data();
            if (!rowData) return;

            AddApproveModal.open("approve-update", rowData.RequestJson, rowData, this.affiliations, this.roles, this.sites);
        });
    }

    updateData(data: UpdateRequest[]): void {
        this.table.clear();
        this.table.rows.add(data).draw();
    }
}

class PreviousUserRequestTable {
    tableId: string;
    table: any;
    data: (UserRequest[] | UpdateRequest[]);
    searchId: string;

    constructor(tableId: string, data: (UserRequest[] | UpdateRequest[]), searchId: string) {
        this.tableId = tableId;
        this.data = data;
        this.searchId = searchId
        this.initialize();
    }

    initialize(): void {
        this.table = $(`#${this.tableId}`).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            columns: this.getColumns(),          
            data: this.data,
            order: [[0, 'asc']]
        });
        this.bindSearch();             
    }

    bindSearch(): void {
        const table = this.table;

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
            const row = table.row(dataIndex).data() as UpdateRequest;

            const searchText = ($(this.searchId).val() as string)?.toLowerCase();

            if (searchText) {
                const combined = `${row.Email} ${row.FirstName} ${row.LastName}`.toLowerCase();
                if (!combined.includes(searchText)) return false;
            }

            return true;
        });

        $(this.searchId).on("keyup", () => {
            table.draw();
        });

        $(this.searchId + "-clear").on("click", () => {
            $("#current-search").val("");
            table.draw();
        });
    }

    getColumns(): any[] {
        return [
            { data: "StatusId", title: "Status", render: (data) => { return UserManagementLookups.getDisplayStatus(data) }, className: "text-left nowrap" },
            { data: "Email", title: "Email", className: "text-left nowrap" },
            { data: "FirstName", title: "First Name", className: "text-left nowrap" },
            { data: "LastName", title: "Last Name", className: "text-left nowrap" },            
        ];
    }

    updateData(data: (UserRequest[] | UpdateRequest[])): void {
        //this.table.clear();
        this.table.columns.adjust();
        this.table.rows.add(data).draw();
    }    

}


// ---APPROVE MODAL---
class AddApproveModal {
    static selectedRequest: UserRequest | UpdateRequest | null = null;
    static selectedCurrentUser: CurrentUserWithRequest | CurrentUser | null = null;
    static mode: "create" | "approve-new" | "approve-update" | "edit-user" = "create"

    static open(mode: "create" | "approve-new" | "approve-update" | "edit-user", request?: any, currentUser?: any, affiliations?: any, roles?: portalRoles[], sites?: any): void {
        this.mode = mode;
        if (mode === "approve-update") {
            this.selectedRequest = currentUser;
        } else {
            this.selectedRequest = request || null;
        }
        this.selectedCurrentUser = currentUser || null;
        const html = UserFormBuilder.build(mode, request, currentUser, affiliations, roles, sites);

        $('#add-approve-modal .modal-body').html(html);
        this.renderHeader(mode);
        this.renderFooter(mode);

        const modal = $('#add-approve-modal');
        modal.find("#modal-footer-buttons").removeClass("d-none");
        modal.find("#modal-processing").addClass("d-none");

        $('#add-approve-modal').modal('show');
    }

    private static renderHeader(mode: "create" | "approve-new" | "approve-update" | "edit-user"): void {
        var header = ``;
        switch (mode) {
            case "create":
                header += `                   
                        Add New User
                        <button type="button" class="close" aria-label="Close" onclick="page.closeAllModals()">
                            <span aria-hidden="true">&times;</span>
                        </button>`;
                break;
            case "approve-new":
                header += `                   
                        New User Request
                        <button type="button" class="close" aria-label="Close" onclick="page.closeAllModals()">
                            <span aria-hidden="true">&times;</span>
                        </button>`;
                break;
            case "edit-user":
                header += `
                        Edit User
                        <button type="button" class="close" aria-label="Close" onclick="page.closeAllModals()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                `;
                break;
            case "approve-update":
                header += ` 
                      Review Update Request
                      <button type="button" class="close" aria-label="Close" onclick="page.closeAllModals()">
                        <span aria-hidden="true">&times;</span>
                      </button>`;
                break;
        }
        $('#add-approve-modal .modal-header').html(header);

    }
    private static renderFooter(mode: "create" | "approve-new" | "approve-update" | "edit-user"): void {
        let buttons = '';

        if (mode === "create") {
            buttons = `<button id="create-new-user" class="btn user-management-btn-save mr-3">Create User</button>
             <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>`;

        }
        else if (mode === "approve-new") {
            buttons = `
                <button id="approve-new-user" class="btn user-management-btn-save mr-3">Approve Request</button>
                <button id="deny-new-user" class="btn user-management-btn ms-3 mr-3">Deny Request</button>
                 <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
            `;
        }
        else if (mode === "approve-update") {
            buttons = `
                <button id="approve-update-user" class="btn user-management-btn-save mr-3">Approve Update</button>
                <button id="deny-update-user" class="btn user-management-btn ms-3 mr-3">Deny</button>
                 <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
            `;
        }
        else if (mode === "edit-user") {
            buttons = `
                <button id="update-user" class="btn user-management-btn-save mr-3">Save Changes</button>
                <button class="btn user-management-btn" onclick="page.closeAllModals()">Close</button>
            `;
        }

        const footerHtml = `
            <div id="modal-footer-actions" class="w-100 d-flex justify-content-end gap-3">
                <div id="modal-footer-buttons" class="d-flex gap-3">
                    ${buttons}
                </div>

                <div id="modal-processing" class="d-none text-center w-100">
                    <div class="spinner-border" role="status"></div>
                    <div class="mt-2">Processing request...</div>
                </div>
            </div>
        `;

        $('#add-approve-modal .modal-footer').html(footerHtml);

    }

    
}

